import { supabase } from "./supabase";

export async function paymentRequest<T>(name: string, body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) {
    let message = "Não foi possível conectar ao pagamento. Tente novamente.";
    if (error.context instanceof Response) {
      try { message = (await error.context.json()).error || message; } catch { /* Keep fallback. */ }
    }
    throw new Error(message);
  }
  if (data?.error) throw new Error(data.error);
  return data as T;
}
